import { Message } from "element-ui"

// 记录加载初始化状态
let isSdkReady = false

// 记录加载配置状态
let isConfig = false

  // 初始化
export function init() {
  if(!window.ysf||!ysf){
    return;
  }
  ysf("onready", function () {
    isSdkReady = true
  })
}

// 配置客户参数
export function config() {
  if(!window.ysf||!ysf){
   return;
  }
 ysf("config", {
    uid: localStorage.getItem('userId') || parseInt(Math.random() * 100),
    name: localStorage.getItem('userName') || '访客',
    data: JSON.stringify([{
      key: "real_name",
      value: localStorage.getItem('userName') || '访客'
    }]),
    success: function () {
      isConfig = true
    }
  })
}

// 打开客服链接
export function open() {
  if (isSdkReady && isConfig) {
    if(ysf){

      window.open(ysf('url'), "ukefu-chat", "height=800, width=760, top=" + (window.screen.availHeight - 30 - 600) / 2 + ", left=" + (window.screen.availWidth - 10 - 750) / 2 + ",toolbar=no, menubar=no, scrollbars=no, resizable=no, directories=no,location=no, status=no")
    }
  } else {
    Message({
      message: '请稍后再试',
      type: "error",
      duration: 2 * 1000
    })
  }
}

const fish = { init, config, open }
export default fish



// WEBPACK FOOTER //
// ./src/utils/fishkefu.js